import type { ActivityModule } from '../../core/activity';
import { runMagicHatActivity, filterStarsLevels } from '../../shared/magic-hat-runner';
import levelsData from './levels.json';
import './style.css';

const LEVELS = filterStarsLevels(levelsData.levels);

export const magicHatPlus: ActivityModule = {
  id: 'magic-hat-plus',
  title: 'Chapéu mágico (soma)',
  description: 'Conte as estrelas e some. Quantas estrelas no total?',
  ageMin: 5,
  ageMax: 9,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/magic-hat-plus/icon.svg',
  category: 'aritmetica',
  totalLevels: LEVELS.length,
  mount: (ctx) => runMagicHatActivity(ctx, {
    operation: 'plus',
    title: 'Chapéu mágico (soma)',
    activityId: 'magic-hat-plus',
    levels: LEVELS,
  }),
};
